import { render, staticRenderFns } from "./PrivateJobDescription.vue?vue&type=template&id=2a0c6790"
import script from "./PrivateJobDescription.vue?vue&type=script&lang=js"
export * from "./PrivateJobDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports